import { render, staticRenderFns } from "./SearchOrUploadView.vue?vue&type=template&id=49b1727a&scoped=true"
import script from "./SearchOrUploadView.vue?vue&type=script&lang=js"
export * from "./SearchOrUploadView.vue?vue&type=script&lang=js"
import style0 from "./SearchOrUploadView.vue?vue&type=style&index=0&id=49b1727a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b1727a",
  null
  
)

export default component.exports